import { ApplicantProfileCitizenshipView } from "./applicant-profile-citizenship-view";
import { useQuery } from "@apollo/client";
import { Empty, Skeleton } from "antd";
import { StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument } from "../../../../generated";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { lookupCountryQuery } from './staff-components-country-query'
import { useNavigate } from "react-router-dom";

interface ApplicantProfileCitizenshipViewContainerProps {
  applicantId: string;
};

export const ApplicantProfileCitizenshipViewContainer: React.FC<ApplicantProfileCitizenshipViewContainerProps> = ({applicantId}) => {
  const navigate = useNavigate();

  const {
    data: countryCitizenshipData,
    loading: countryCitizenshipDataLoading,
    error: countryCitizenshipError,
  } = useQuery(StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument, {
    variables: {
      applicantUserId: applicantId,
    },
  });

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const handleEditToggle = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/edit");
    navigate(newPath);
  };

  if (countryLoading || countryCitizenshipDataLoading) {
    return <Skeleton active />;
  }

  if (
    countryCitizenshipError ||
    !countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
  ) {
    console.log(
      "countryCitizenshipData",
      JSON.stringify(countryCitizenshipData, null, 2)
    );
    return (
      <Empty
        description={`There was an error loading the citizenship data. Please try again! ${countryCitizenshipError}`}
      />
    );
  }

  if (countryError || !countryData?.countries?.eventPayload?.countries) {
    console.log("countryData", JSON.stringify(countryData, null, 2));
    return (
      <Empty
        description={`There was an error loading the country data. Please try again! ${countryError}`}
      />
    );
  }

  return (
    <ComponentQueryLoader
      hasData={
        countryData?.countries &&
        countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
      }
      loading={countryCitizenshipDataLoading || countryLoading}
      error={countryCitizenshipError || countryError}
      hasDataComponent={
        <ApplicantProfileCitizenshipView
          citizenship={
            countryCitizenshipData?.applicantUser?.personalInformation
              ?.citizenship
          }
          countries={countryData?.countries?.eventPayload?.countries}
          onEditToggle={handleEditToggle}
        />
      }
    />
  );
};
